import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import { sizePerPageList } from "../../../utility";

export const UomTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const columns = [
    {
      text: "Material",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "UOM",
      dataField: "uom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Numerator",
      dataField: "numerator",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Dumerator",
      dataField: "denumerator",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Description",
      dataField: "discription",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Update Date",
      dataField: "update_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  return (
    <BootstrapTable
      remote
      wrapperClasses="table-responsive"
      classes="table table-head-custom table-vertical-center overflow-hidden"
      bootstrap4
      bordered={false}
      keyField="customerId"
      data={data === null ? [] : data}
      columns={columns}
      pagination={paginationFactory(options)}
      onTableChange={onTableChange}
    >
      <PleaseWaitMessage entities={loading ? null : data} />
      <NoRecordsFoundMessage entities={loading ? null : data} />
    </BootstrapTable>
  );
};
